import { render, staticRenderFns } from "./postApplicantReadonly.vue?vue&type=template&id=c91f84b0&scoped=true"
import script from "./postApplicantReadonly.vue?vue&type=script&lang=js"
export * from "./postApplicantReadonly.vue?vue&type=script&lang=js"
import style0 from "./postApplicantReadonly.vue?vue&type=style&index=0&id=c91f84b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91f84b0",
  null
  
)

export default component.exports